<template>
  <div id="app">
   <router-view v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: "App",
    data () {
      return {
        spinShow: true
      }
    },
    created () {
      axios.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch('logout')
                    .then()
                    .catch()
          }
          throw err;
        });
      });
    },
  }
</script>

<style lang="scss">
@import "./assets/css/main.css";
@import "./assets/css/icon.css";
@import "./assets/css/color-dark.css";
#app {
  font-family: PingFangSC-Regular,Helvetica;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: rem(14);
}
</style>